import Swiper from 'swiper/bundle';
import "swiper/css/bundle";

class SolutionGallerySolutions {
	static block_name = "b-solution-gallery-solutions";

	constructor($elem) {
		this.$elem = $elem;
	}

	onInit() {
		const it = this;

		it.$elem.find(`.${SolutionGallerySolutions.block_name}__slider`).each(function(){
			this.swiper = undefined;
		});

		this.setSwiper();

		$(window).resize(function () {
			it.setSwiper();
		});
	}

	setSwiper() {
		let breakpoint = window.matchMedia('(min-width: 1200px)');
		if (breakpoint.matches) {
			if (this.swiper !== undefined && !this.swiper.destroyed) {
				this.swiper.destroy(true, true);
			}
		} else {
			if (this.swiper === undefined || this.swiper.destroyed) {
				this.swiper = new Swiper(this.$elem.find(`.${SolutionGallerySolutions.block_name}__slider`).get(0), {
					speed: 400,
					spaceBetween: 40,
					slidesPerView: 1,
					uniqueNavElements: false,

					breakpoints: {
						768: {
							slidesPerView: 2,
							spaceBetween: 40
						},
					},

					pagination: {
						bulletClass: `${SolutionGallerySolutions.block_name}__slider-pagination-bullet`,
						bulletActiveClass: `${SolutionGallerySolutions.block_name}__slider-pagination-bullet-active`,
						el: this.$elem.find(`.${SolutionGallerySolutions.block_name}__slider-pagination`).get(0),
						clickable: true,
					},

					navigation: {
						prevEl: this.$elem.find(`.${SolutionGallerySolutions.block_name}__arrow--prev`).get(),
						nextEl: this.$elem.find(`.${SolutionGallerySolutions.block_name}__arrow--next`).get(),
					},
				});

				let swiper = this.swiper;

				setTimeout(function() {
					swiper.update();
					swiper.updateSize();
					swiper.updateSlides();
				}, 500);
			}
		}
	}
}

export default SolutionGallerySolutions;
